export default __webpack_public_path__ + "static/media/about3.db21feb1.jpg";